// Card #3177 (same defect as #2660, which fixed it for announcer-fe). A
// boolean-ish riderStatus ("Yes"/"No"/"True"/"False") is never a real
// division: it is FVD's chrQualifyID text leaking into tblRider.chrStatus
// (card #2346 AC1; "Open" is legal in BOTH fields, which hides the mix-up).
// The public scoreboard reads riderStatus as the #821 division proxy, so a
// leaked value became its own division table heading, its own division-rank
// bucket, and a verbatim status chip.
//
// DECIDED (card #3177 comment): ONE shared helper, applied at the score-api
// source (so the scoreboard payload never carries the leaked value) and again
// in score-fe's consumers as defence. A boolean-ish value is treated exactly
// like a blank riderStatus, i.e. it folds into Open (#2027 blank=Open rule).
//
// Whole-value match only, after trim: a division that merely CONTAINS such a
// word ("Yes Please", "Not Yes") is a real division and is kept verbatim, in
// its stored casing (#2027 first-seen casing rule). Pure and dependency-free;
// source subpath export (`score-common/rider-status`), no dist rebuild needed.

const BOOLEANISH_RE = /^(no|yes|true|false)$/i;

/** True when `raw` is exactly Yes/No/True/False (any case, surrounding space ignored). */
export function isBooleanishRiderStatus(raw) {
  return typeof raw === "string" && BOOLEANISH_RE.test(raw.trim());
}

/**
 * The riderStatus to treat as a division: the trimmed stored value, or
 * `undefined` when it is blank, not a string, or boolean-ish (all of which
 * mean "no division", which callers fold into Open).
 */
export function cleanRiderStatus(raw) {
  if (typeof raw !== "string") return undefined;
  const trimmed = raw.trim();
  if (!trimmed || BOOLEANISH_RE.test(trimmed)) return undefined;
  return trimmed;
}
